import { render, staticRenderFns } from "./DataAnalysis.html?vue&type=template&id=2efe2c96&external"
import script from "./DataAnalysis.vue?vue&type=script&lang=js"
export * from "./DataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./DataAnalysis.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports